<div class="d-inline-flex flex-column align-content-between h-100 w-100">
    <div class="itemList">
        <div *ngFor="let el of lst; trackBy: trackByFunction" class="permission_inner_right_item"
             [attr.title]="el.name">
            <span>{{el.name}}<span *ngIf="el.Default" class="default_group">*</span></span>
            <div class="permission_inner_right_click" (click)="removeGroup(el)" [hidden]="el.Default">
                <img src="../../../App_Themes/clearview-default/icons/utility/remove-16px.svg">
            </div>
        </div>
    </div>
    <div style="flex: 1 1;font-size: 12px; margin-bottom: 5px;margin-left:10px;" class="default_group"
         cvLocalizedText langSection="Users" langKey="Default_From_Role_Star">
        *Default from Role
    </div>
</div>
